<div class="row d-flex">
  <div class="col-6 col-lg-3 mr-auto p-0">
    <h1>
      <mdb-icon fas icon="tasks"></mdb-icon> Nota de crédito a Tercero
    </h1>
  </div>
  <div class="col-6 col-lg-6 pb-1">
    <!-- COMPONENTE CARD VIEW FOLIOS -->
    <app-view-folios [codigos_dte]="codigos_dte" [contadorFacturas]="contadorFacturas"></app-view-folios>
  </div>
</div>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Compras</span>
      <span> /</span>
      <span>Nota de crédito a Tercero</span>
    </p>
  </div>
</div>
<!-- Heading -->


<app-nota-credito-cabecera (onCabeceraChange)="handleCabeceraChange($event)"></app-nota-credito-cabecera>

<app-nota-credito-detalles (onDetalleDocumentoChange)="onDetalleDocumentoChange($event)"></app-nota-credito-detalles>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">

    <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect (click)="clearFromButton()">
      Limpiar
    </button>

    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="GuardarNotaCredito()">
      Guardar
    </button> -->
    <app-api-button (click2)="beginSave()" [processing]="processing">Guardar</app-api-button>

  </div>
</div>

<app-modal-confirm title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
</app-modal-confirm>